module.exports = __webpack_public_path__ + "img/Rectangle 18.b93c088f.png";